import { CommonInfoService } from './../../cart-process/common-info.service';
import { Injectable } from '@angular/core';
import { CommonModalService } from '../../utils/modals/common-modal.service';
import { CommonModalTemplatesEnum } from '../../utils/modals/common-modal-templates.enum';

export enum FormSectionTypeEnum {
  USER_AUTHENTICATION,
  DELIVERY,
  PAYMENT,
  RECAPTCHA,
  SUMMARY,
}

@Injectable()
export class FormStepsService {
  public sectionsCounter = 0;
  public sections = {
    [FormSectionTypeEnum.USER_AUTHENTICATION]: {
      isVisible: false,
      isOpen: false,
      sectionNumber: 0,
      dataChanged: false
    },
    [FormSectionTypeEnum.DELIVERY]: {
      isVisible: false,
      isOpen: false,
      sectionNumber: 0,
      dataChanged: false
    },
    [FormSectionTypeEnum.PAYMENT]: {
      isVisible: false,
      isOpen: false,
      sectionNumber: 0,
      dataChanged: false
    },
    [FormSectionTypeEnum.RECAPTCHA]: {
      isVisible: false,
      isOpen: false,
      sectionNumber: 0,
      dataChanged: false
    },
    [FormSectionTypeEnum.SUMMARY]: {
      isVisible: false,
      isOpen: false,
      sectionNumber: 0,
      dataChanged: false
    },
  };

  constructor(
    private commonModalService: CommonModalService,
    private commonInfo: CommonInfoService,
  ) {
  }

  public setSectionVisibility(sectionName: FormSectionTypeEnum) {
    this.sectionsCounter += 1;

    this.sections[sectionName].isVisible = true;
    this.sections[sectionName].sectionNumber = this.sectionsCounter;

    if (!this.sections[sectionName - 1]) {
      this.sections[sectionName].isOpen = true;
    } else if (this.sections[sectionName - 1]?.isVisible) {
      this.sections[sectionName].isOpen = false;
    }
  }

  public getSectionNumber(sectionName: FormSectionTypeEnum): number {
    return this.sections[sectionName].sectionNumber;
  }

  public getSection(sectionName: FormSectionTypeEnum) {
    return this.sections[sectionName];
  }

  public openNextSection(sectionName: FormSectionTypeEnum) {
    this.sections[sectionName].dataChanged = true;

    const nextSection = this.sections[sectionName + 1];

    if (!nextSection?.isOpen) {
      nextSection.isOpen = true;
    }
  }

  public closeSections(sectionName: FormSectionTypeEnum) {
    for (let i = sectionName; i < Object.keys(this.sections).length; i++) {
      if (sectionName + 1 && this.sections[i].isOpen) {
        this.sections[i].isOpen = false;
      }
    }
  }

  public openModalConfirmation(textType: 'authentication' | 'delivery') {
    let resolve, reject;

    const promise = new Promise((_resolve, _reject) => {
      resolve = _resolve;
      reject = _reject;
    });

    const header = `dataChangeConfirmation.${textType === 'delivery' ? 'deliveryChange' : (this.commonInfo.isVirginBrand ? 'identityChangeVirgin' : 'identityChange')}`;
    const description = `dataChangeConfirmation.${this.commonInfo.isVirginBrand
        ? 'identityChangeDescriptionVirgin'
        : textType === 'delivery' ? 'deliveryChangeDescription' : 'identityChangeDescription'}`;

    const modalData = {
      templateName: CommonModalTemplatesEnum.DATA_CHANGE_CONFIRMATION,
      header,
      description,
      isVirginBrand: this.commonInfo.isVirginBrand,
      cancel: (event: Event) => {
        event.preventDefault();

        reject();
      },
      confirmation: (event: Event) => {
        event.preventDefault();

        resolve();
      }
    };

    this.commonModalService.setData(modalData);

    return promise;
  }
}
